<template>
    <div>
        <div class="gradient-box gradient-box-peach" />
        <div class="row" data-test-view="learning">
            <div class="col-md-2 hidden-xs hidden-sm">
                <l-side-menu>
                    <l-side-menu-picture :src="icon"></l-side-menu-picture>

                    <l-side-menu-element
                        v-for="item in menu[menuType]"
                        :key="item.path"
                        :show="item.show"
                        :type="item.type"
                        :icon="item.icon"
                        :label="item.label"
                        :path="item.path"
                        :handler="() => goTo(item.path)"
                        :active="item.active"
                    ></l-side-menu-element>
                </l-side-menu>
            </div>
            <div class="col-md-10">
                <l-card-content>
                    <router-view @new="v => (isPathNew = Boolean(v))"></router-view>
                </l-card-content>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LCardContent from "@/components/LCardContent";
import LSideMenu from "@/components/LSideMenu";
import LSideMenuElement from "@/components/LSideMenuElement";
import LSideMenuPicture from "@/components/LSideMenuPicture";

import icon from "@/img/icons/learning.png";

export default {
    components: {
        LCardContent,
        LSideMenu,
        LSideMenuElement,
        LSideMenuPicture,
    },
    data() {
        return {
            icon,
            menuType: "main",
            pathId: null,
            isPathNew: false,
        };
    },
    computed: {
        ...mapGetters({
            rights: "users/current/rights",
        }),
        menu() {
            return {
                main: [
                    {
                        show: this.rights.L_VIEW,
                        icon: "fa-chart-line",
                        label: this.$t("learning.menu.myProgress"),
                        path: "/learning/progress",
                    },
                    {
                        show: this.rights.L_VIEW,
                        icon: "fa-university",
                        label: this.$t("learning.menu.myContent"),
                        path: "/learning/library",
                    },
                    {
                        show: this.rights.L_PATH,
                        icon: "fa-map-signs",
                        label: this.$t("learning.menu.pathAdmin"),
                        path: "/learning/admin/path",
                    },
                    {
                        show: this.rights.L_ELEMENT,
                        icon: "fa-puzzle-piece",
                        label: this.$t("learning.menu.contentAdmin"),
                        path: "/learning/admin/element",
                    },
                    {
                        show: this.rights.L_ANALYTICS,
                        icon: "fa-line-chart",
                        label: this.$t("learning.menu.analytics"),
                        path: "/learning/analytics",
                    },
                ],
                path: [
                    {
                        show: true,
                        icon: "fa-caret-left",
                        path: "/learning/admin/path",
                        label: this.$t("learning.admin.path.menu.back"),
                        type: "back",
                        active: false,
                    },
                    {
                        show: this.rights.L_PATH && !this.isPathNew,
                        icon: "fa-search",
                        path: `/learning/admin/path/${this.pathId}/dashboard`,
                        label: this.$t("learning.admin.path.menu.dashboard"),
                    },
                    {
                        show: this.rights.L_PATH,
                        icon: "fa-edit",
                        path: `/learning/admin/path/${this.pathId}/edit/basics`,
                        label: this.$t("learning.admin.path.menu.basics"),
                        active: this.isPathNew,
                    },
                    {
                        show: this.rights.L_PATH && !this.isPathNew,
                        icon: "fa-calendar",
                        path: `/learning/admin/path/${this.pathId}/edit/steps`,
                        label: this.$t("learning.admin.path.menu.steps"),
                    },
                    {
                        show: this.rights.L_PATH && !this.isPathNew,
                        icon: "fa-user",
                        path: `/learning/admin/path/${this.pathId}/edit/targeting`,
                        label: this.$t("learning.admin.path.menu.targeting"),
                    },
                    {
                        show: this.rights.L_PATH && !this.isPathNew,
                        icon: "fa-rocket",
                        path: `/learning/admin/path/${this.pathId}/edit/status`,
                        label: this.$t("learning.admin.path.menu.status"),
                    },
                ],
            };
        },
    },
    watch: {
        $route: {
            immediate: true,
            handler(route) {
                if (route.path.startsWith("/learning/admin/path/") && route.params.pathId) {
                    this.pathId = route.params.pathId;
                    this.menuType = "path";
                } else {
                    this.menuType = "main";
                }

                this.isRouteActive(route.path);
            },
        },
    },
    methods: {
        goTo(path) {
            this.$router.push(path);
        },
        isRouteActive(path) {
            this.menu[this.menuType]
                .filter(item => item.type !== "back") // Back buttons should never be active!
                .forEach(item => {
                    this.$set(item, "active", path.startsWith(item.path));
                });
        },
    },
};
</script>

<style scoped></style>
